import { CatalogStore, QuotaExceeded } from '../catalog/CatalogStore';
import { el } from '../dom';

const ICONS = {
  camera: '<svg class="hero" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M4 8h3l2-3h6l2 3h3v12H4z"/><circle cx="12" cy="14" r="3.5"/></svg>',
  shutter: '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M9 3h6l2 3h4v14H3V6h4z"/><circle cx="12" cy="13" r="4" fill="#fff"/></svg>',
  library: '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M4 5h7v7H4zm9 0h7v7h-7zM4 14h7v7H4zm9 0h7v7h-7z"/></svg>',
  check: '<svg viewBox="0 0 24 24" fill="currentColor" width="18" height="18"><path d="M9.5 16.2 5.8 12.5l1.4-1.4 2.3 2.3 6.3-6.3 1.4 1.4z"/></svg>',
};

/**
 * The Camera tab: a shot goes straight into the catalog (and from there into
 * recognition), with a gallery picker beside it — the same pair as
 * Singline/Sources/Views/CameraView.swift. Desktop browsers rarely expose a
 * camera to `capture`, so the picker is permanent.
 */
export class CameraView {
  private confirmation: number | undefined;
  private readonly captureInput: HTMLInputElement;
  private readonly libraryInput: HTMLInputElement;

  constructor(
    private readonly root: HTMLElement,
    private readonly store: CatalogStore,
  ) {
    this.captureInput = el('input', {
      class: 'hidden-input',
      type: 'file',
      accept: 'image/*',
      capture: 'environment',
    });
    this.libraryInput = el('input', {
      class: 'hidden-input',
      type: 'file',
      accept: 'image/*',
    });
    this.captureInput.addEventListener('change', () => void this.take(this.captureInput));
    this.libraryInput.addEventListener('change', () => void this.take(this.libraryInput));
    this.render(false);
  }

  private render(showPill: boolean): void {
    this.root.replaceChildren();
    this.root.className = 'camera tab-panel';
    const hero = el('div');
    hero.innerHTML = ICONS.camera;
    const take = el('button', { class: 'big-button accent', type: 'button' });
    take.innerHTML = `${ICONS.shutter}<span>Take Photo</span>`;
    take.addEventListener('click', () => this.captureInput.click());
    const pick = el('button', { class: 'big-button green', type: 'button' });
    pick.innerHTML = `${ICONS.library}<span>Choose from Library</span>`;
    pick.addEventListener('click', () => this.libraryInput.click());
    this.root.append(hero, take, pick, this.captureInput, this.libraryInput);
    if (showPill) {
      const pill = el('div', { class: 'pill' });
      pill.innerHTML = `${ICONS.check}<span>Added to library</span>`;
      this.root.append(pill);
    }
  }

  private async take(input: HTMLInputElement): Promise<void> {
    const file = input.files?.[0];
    input.value = '';
    if (!file) return;
    try {
      await this.store.addCameraImage(file);
      this.flash();
    } catch (error) {
      const message = error instanceof QuotaExceeded
        ? error.message
        : error instanceof Error ? error.message : 'Could not add that photo.';
      window.alert(message);
    }
  }

  private flash(): void {
    window.clearTimeout(this.confirmation);
    this.render(true);
    this.confirmation = window.setTimeout(() => this.render(false), 2000);
  }
}
